import classnames from 'classnames';
import React from 'react';

const CSS = require('./Strong.less');

interface StrongProps {
  children: any;
  weight?: 'bold' | 'semi-bold' | 'medium';
  className?: string;
  color?: undefined | 'razzmatazz';
  rest?: { [name: string]: any };
}

function Strong({
  children,
  className,
  weight = 'bold',
  color,
  ...rest
}: StrongProps) {
  const classes = classnames(CSS.Strong, {
    [className]: !!className,
    [CSS.Bold]: weight === 'bold',
    [CSS.SemiBold]: weight === 'semi-bold',
    [CSS.Medium]: weight === 'medium',
    [CSS.Razzmatazz]: color === 'razzmatazz',
  });

  return (
    <strong className={classes} {...rest}>
      {children}
    </strong>
  );
}

export default Strong;
